// ==================================================
//  お知らせ タブ
// ==================================================
document.addEventListener('DOMContentLoaded', () => {
  // Get all tab buttons and content tabs
  const categoryTabs = document.querySelectorAll('.js-newsCategoryTab');
  const contentTabs = document.querySelectorAll('.js-newsContentTab');

  // If no tabs found, do nothing
  if (!categoryTabs.length || !contentTabs.length) return;

  categoryTabs.forEach((tab, idx) => {
    tab.addEventListener('click', () => {
      // Remove is-active from all tabs and content
      categoryTabs.forEach((t) => t.classList.remove('is-active'));
      contentTabs.forEach((c) => c.classList.remove('is-active'));

      // Add is-active to clicked tab and corresponding content
      tab.classList.add('is-active');
      if (contentTabs[idx]) {
        contentTabs[idx].classList.add('is-active');
      }
    });
  });

  // Set first tab as active by default
  if (categoryTabs[0] && contentTabs[0]) {
    categoryTabs[0].classList.add('is-active');
    contentTabs[0].classList.add('is-active');
  }
});
